var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sales-chart__chart-container" },
    [
      _c("h3", [_vm._v("TIER MIX")]),
      _vm._v(" "),
      _vm.loading
        ? _c("ChartLoader")
        : _c("div", { staticClass: "css-grid sales-chart__chart-wrapper" }, [
            _c("div", { staticClass: "sales-chart__chart-legend" }, [
              _c("table", { staticClass: "pieTable" }, [
                _c("tr", [
                  _c(
                    "th",
                    {
                      staticClass: "pieTable__header pieTable__header--key",
                      attrs: { colspan: "2" }
                    },
                    [_vm._v("Tier")]
                  ),
                  _vm._v(" "),
                  _c(
                    "th",
                    { staticClass: "pieTable__header pieTable__header--value" },
                    [_vm._v("Units Sold")]
                  )
                ]),
                _vm._v(" "),
                _vm.mixTierData
                  ? _c(
                      "tbody",
                      _vm._l(_vm.formattedDataWithNegatives, function(
                        units,
                        tier,
                        index
                      ) {
                        return _c("tr", { key: index }, [
                          _c("td", { staticClass: "chartColor" }, [
                            _c(
                              "div",
                              {
                                staticClass: "chartColor__box",
                                class: "chartColor__box--" + _vm.ucFirst(tier)
                              },
                              [_vm._v(" ")]
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "pieTable__key" }, [
                            _vm._v(_vm._s(_vm.ucFirst(tier)))
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "pieTable__value" }, [
                            _vm._v(_vm._s(_vm.currency(units)))
                          ])
                        ])
                      }),
                      0
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("tr", { staticClass: "pieTable__footer" }, [
                  _c("td", { staticClass: "pieTable__footer chartColor" }, [
                    _vm._v(" ")
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "pieTable__footer pieTable__key" }, [
                    _vm._v("TOTAL")
                  ]),
                  _vm._v(" "),
                  _c(
                    "td",
                    { staticClass: "pieTable__footer pieTable__value" },
                    [_c("span", [_vm._v(_vm._s(_vm.currency(_vm.totals)))])]
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "sales-chart__chart h-center-align" },
              [
                _c("ChartCustom", {
                  staticClass: "chart__mix",
                  attrs: {
                    "chart-settings": _vm.chartConfig,
                    "allow-resize": false,
                    dimensions: _vm.chartConfig.size
                  }
                })
              ],
              1
            )
          ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }